import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * POS / customer payment success. No navigation to /, /login, or /admin.
 * Customer can close the tab; no redirect into admin dashboard.
 */
export default function PaymentSuccess() {
  const location = useLocation();
  const { restaurantName, amount, total } = location.state || {};
  const displayAmount = typeof amount === 'number' ? amount : typeof total === 'number' ? total : null;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Success Icon */}
        <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
          <svg
            className="w-12 h-12 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        {/* Success Message */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-gray-900">
            Pago completado correctamente.
          </h1>
          {displayAmount != null && (
            <p className="text-lg font-semibold text-gray-700">
              RD${typeof displayAmount === 'number' ? displayAmount.toFixed(2) : displayAmount} pagados.
            </p>
          )}
          <p className="text-gray-600">
            Puedes cerrar esta página o volver al restaurante.
          </p>
          <p className="text-gray-600">
            Gracias por usar YAP.
          </p>
        </div>

        {/* Restaurant name if provided */}
        {restaurantName && (
          <div className="bg-gray-50 rounded-2xl p-4">
            <p className="text-sm text-gray-500">Restaurante</p>
            <p className="text-lg font-semibold text-gray-900">{restaurantName}</p>
          </div>
        )}

        {/* No redirect button: instruct to close tab */}
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
          <p className="text-sm text-blue-800">
            Puedes cerrar esta pestaña cuando quieras. No serás redirigido.
          </p>
        </div>
      </div>
    </div>
  );
}
